var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTimeLapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 79,
    viewBox: "0 0 92 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BCC6DA",
    fillRule: "nonzero",
    d: "M62.997 13.678l.082-1.582c1.464.077 2.767-1.101 2.844-2.57.077-1.468-1.096-2.775-2.56-2.852l-8.105-.425c-1.463-.076-2.767 1.101-2.844 2.57-.077 1.468 1.096 2.776 2.56 2.853l-.083 1.581c-14.967 1.255-27.119 13.418-27.93 28.894-.883 16.832 12.022 31.214 28.796 32.092 16.774.88 31.113-12.076 31.995-28.907.811-15.476-10.002-28.843-24.755-31.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M71.835 30.826L61.43 45.923a5.968 5.968 0 0 1-9.347.607 5.963 5.963 0 0 1 1.58-9.228l16.11-8.768a1.585 1.585 0 0 1 2.063 2.292z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.477,
    cy: 42.652,
    fill: "#BCC6DA",
    rx: 3.758,
    ry: 3.771,
    transform: "rotate(3 56.477 42.652)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 21.001,
    fill: "#FF7A00",
    stroke: "#FFF",
    strokeWidth: 4.003
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.967 18.73c0 .02.3-.249.3-.23H29l-3.009 3.357-3.049-3.357h1.734c0-.019.379.25.379.23 0-3.203-2.571-5.793-5.74-5.793-1.434 0-2.75.538-3.746 1.42l-1.275-1.458A7.58 7.58 0 0 1 19.316 11c4.224 0 7.651 3.472 7.651 7.73zM11.033 19.27c0-.02-.3.249-.3.23H9l3.009-3.357 3.049 3.357h-1.734c0 .019-.379-.25-.379-.23 0 3.203 2.571 5.793 5.74 5.793 1.434 0 2.75-.538 3.746-1.42l1.275 1.458A7.58 7.58 0 0 1 18.684 27c-4.224 0-7.651-3.472-7.651-7.73z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeLapse);
export default __webpack_public_path__ + "static/media/icon-time-lapse.1c2daa5c392782df2a329bddb1d278da.svg";
export { ForwardRef as ReactComponent };